import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import { isMobileDevice } from 'src/utils/util';
import { scrollBarStyle } from 'src/styles/CommonStyles.styled';
import { ENVIRONMENTVARIABLE } from 'src/constants/appConstants';

let isMobile = isMobileDevice();

// export const OrderFilterContainer = styled.div`
//     display: flex;
//     flex-direction: column;
//     background-color: #f5f5f5;
//     margin: 0;
//     width: 100%;
//     ${media.mobileDevice`
//         width: 100%;
//         padding: 0;
//         margin: 0;
//         border-top-left-radius: 20px;
//         border-top-right-radius: 20px;
//         background: #f5f5f5 0% 0% no-repeat padding-box;
//     `}
// `;

// export const FilterContainer = styled.div`
//     display: block;
//     margin-bottom: 10px;
//     padding: 0;
//     height: auto;
//     background: #ffffff 0% 0% no-repeat padding-box;
//     border-radius: 6px;

//     ${media.mobileDevice`
//         width: 100%;
//         padding: 0;
//         margin: 0;
//         border-top-left-radius: 20px;
//         border-top-right-radius: 20px;
//         background: #f5f5f5 0% 0% no-repeat padding-box;
//     `}
// `;

export const OrdersContainer = styled.div`
    /* display: flex;
    flex-direction: column; */
    ${scrollBarStyle}
    margin: 0;
    padding: 10px 10px 0 10px;
    background-color: #ffffff;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    overflow-y: ${isMobile ? '' : 'scroll'};
    height: ${isMobile ? '' : 'calc(100vh - 11rem)'};
    width: 100%;

    /* ${media.largeDevice`
        height:auto;
    `} */
    ${media.mediumDevice`
        padding: 10px 10px 80px 10px;
          &::-webkit-scrollbar {
                display: none;
            }
    `}
    ${media.mobileDevice`
        height:auto;
        min-height:${(props) => (props.minHeight ? props.minHeight : '450px')};
        width: 100%;
        overflow-y: scroll; 
        padding: 0 0 4rem 0;        
        padding-bottom:${
            ENVIRONMENTVARIABLE
                ? 'max(4rem,calc(4*env(safe-area-inset-bottom)))'
                : '4rem'
        }; 
        margin: -1px 0px;        
        border-top-left-radius: ${(props) => (props.filterCount ? 0 : '20px')};
        border-top-right-radius: ${(props) => (props.filterCount ? 0 : '20px')};
        background: #f5f5f5 0% 0% no-repeat padding-box;
          &::-webkit-scrollbar {
        display: none;
    }
    `}
`;

export const OrderContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: 0;
    justify-content: ${isMobile ? 'center' : 'flex-start'};

    ${media.mobileDevice`       
        flex-direction: column;
        justify-content: space-between;
        & > * {
            flex: 0;
        }

    `}
`;

export const BottomBar = styled.div`
    width: 100%;
    display: flex;
    flex-direction: ${(props) => (props.isLastOrder ? 'row-reverse' : 'row')};
    justify-content: space-between;
`;
